import ComponentsFactory from 'foundation/components-factory';
import ViewOrderUrlComponent from './js/view-order-url.component';

ComponentsFactory.getInstance().define('view-order-url', ViewOrderUrlComponent);
